/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  InviteeData: null,
  InviteeCount: null,
  taskDetails: null,
  ProjectDetails: null,
  loading: false
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.GetInviteeAction.REQUEST_INVITEE_DATA:
      return {
        ...state,
        loading: true
      };
    case actions.GetInviteeAction.INVITEE_DATA_RECEIVED:
      return {
        ...state,
        InviteeData: action.data?.filterRecruitsGroupwise,
        InviteeCount: action.data?.GroupwiseInvitedCount,
        taskDetails: action.data?.taskDetails,
        ProjectDetails: action.data?.ProjectDetails[0],
        loading: false,
        // userid: action.payload.user_ID,
        // projectid: action.payload.project_ID,
      };

    default:
      return state;
  }
};

export default reducer;
